import { toast } from "sonner";
import TopBar from "@/components/top-bar";
import Section from "@/components/section";
import Row from "@/components/row";
import { copyToClipboard } from "@/utils/clipboard";
import { getUserAgent } from "@/utils/device-info";
import { useProfileStore } from "@/store/profile-store";
import { APP_VERSION } from "@/version";

export default function DeviceInfoPage() {
  const profile = useProfileStore((s) => s.profile);
  const userAgent = getUserAgent();

  const fullName = [profile?.first_name, profile?.last_name]
    .filter(Boolean)
    .join(" ");

  // A one-tap copy of everything support usually asks for.
  const copyDiagnostics = async () => {
    const lines = [
      fullName && `نام: ${fullName}`,
      profile?.phone && `موبایل: ${profile.phone}`,
      profile?.id != null && `شناسه: ${profile.id}`,
      `نسخه: Amoozim Vitrin v${APP_VERSION}`,
      `User-Agent: ${userAgent}`,
    ].filter(Boolean);
    const ok = await copyToClipboard(lines.join("\n"));
    toast[ok ? "success" : "error"](
      ok ? "اطلاعات دستگاه کپی شد" : "کپی اطلاعات ناموفق بود",
    );
  };

  return (
    <div className="min-h-svh bg-secondary-background pb-10">
      <TopBar title="اطلاعات دستگاه" />

      <Section title="مرورگر / دستگاه">
        <p
          className="px-4 pt-3 text-xxs leading-5 text-default-500 break-all"
          dir="ltr"
        >
          {userAgent || "نامشخص"}
        </p>
        <Row
          icon="document-text"
          iconClassName="bg-default-400"
          title="کپی اطلاعات دستگاه"
          subtitle="برای ارسال به پشتیبانی"
          trailing={<span className="text-xs font-medium text-primary">کپی</span>}
          onClick={copyDiagnostics}
        />
      </Section>

      <Section title="برنامه">
        <Row
          title="نسخه"
          trailing={
            <span className="text-xs text-default-500" dir="ltr">
              v{APP_VERSION}
            </span>
          }
        />
      </Section>
    </div>
  );
}
